<template>
    <div class="large-container">
        <form class="login-form" @submit.prevent="RecoverPassword($event)" >
            <h2 class="left">Escriba su nueva contraseña</h2>
            <input type="password" class="form-control left" required name="newPassword" id="newPassword" placeholder="Nueva Contraseña">
            <input type="password" class="form-control left" required name="newPasswordConfirmation" id="newPasswordConfirmation" placeholder="Confirmar Nueva Contraseña">
            <div class="large-container">
                <input class="ui blue button wide" type="submit" value="Cambiar contraseña" >
            </div>
            <br><br>
        </form>
    </div>
</template>

<script>
export default {
    methods:{
        RecoverPassword(e){
            let recoverPassword = {
                customerId:this.$route.query.customerId,
                passwordRecoveryCode:this.$route.query.passwordRecoveryCode,
                formContent:e
            }
            this.$store.dispatch('RecoverPassword',recoverPassword )
        }
    }
}
</script>